import React from 'react'
import { Link } from 'react-router-dom'

function LenderOnboarded() {
  return (
    <>
        <section id="c-sectionlenderonboard" className="c-sectionWrapper bg-light p-5 border-top border-light">
		    <div className="container-fluid w-100 p-5 d-flex justify-content-center flex-column" >
                <div className='text-center'>
                    <h1 class="c-heading46Bold mt-5 v"> Our EV Lending Partners </h1>
                </div>
                <div class="d-flex w-100 justify-content-center" style={{alignItems: 'center', flexWrap: 'wrap', gap: '80px',justifyContent: 'center', padding: '24px 10% 64px'}}>
                    <div>
                        <a href="/dlp-details/lazypay">
                            
                        </a>
                        <Link to='/choice-DLA'  className="navbar-brand c-scrollToDiv" data-scroll-to="#c-sectionlenderChoice">
                            <img alt="Lazypay logo" width="170" src="./images/logo/choice.png" />
                        </Link>
                    </div>
                    <div>
                        <a href="https://mufingreenfinance.com/" target="_blank">
                            <img alt="Paysense logo" width="170" src="./images/logo/mufin_green_logo.png" />
                        </a>
                    </div>
                    {/* <div>
                        <a href="/dlp-details/kreditbee">
                            <img width="214" alt="KreditBee logo" src="https://assets.payufin.com/images/kb.svg" />
                        </a>
                    </div>
                    <div>
                        <a href="/dlp-details/upwards">
                            <img alt="Upwards logo" width="100" src="https://assets.payufin.com/images/upwards.png" />
                        </a>
                    </div>
                    <div>
                        <a href="/dlp-details/niro">
                            <img alt="Niro logo" width="120" src="https://assets.payufin.com/images/Niro_logo.svg" />
                        </a>
                    </div>
                    <div><a href="/dlp-details/smartcoin">
                        <img alt="SmartCoin logo" width="190" src="https://assets.payufin.com/images/SmartCoinLogo.png"/>
                        </a>
                    </div>
                    <div>
                        <a href="/dlp-details/payupayments">
                            <img alt="PayUPayments logo" width="130" class="mb-4" src="https://assets.payufin.com/images/PLG3.svg" />
                        </a>
                    </div> */}
                </div> 
            </div>
        </section>
    </>
  )
}

export default LenderOnboarded